module.exports = "/packs/images/svg/search~e36900e47e73570ac3c75dff1e42f75c.svg";